<div class="zwi-top-spacer" [class]="classObject()"></div>
